import React, { Fragment, useEffect, useMemo, useState } from 'react';
import Tablereact from '../common/tabulator/tablereact';
import Button from 'react-bootstrap-button-loader';
import Loader from '../common/loaderapp';

const Niveles = () => {
    const [datos, setDatos] = useState([]);
    const [load, setLoad] = useState(false);
    const [editando, setEditando] = useState(false);
    const [nivelActual, setNivelActual] = useState(null);
    const [formData, setFormData] = useState({});
    const [saving, setSaving] = useState(false);

    const cargarNiveles = async () => {
        try {
            setLoad(false);
            const response = await fetch('/p_niveles', { headers: { 'Content-Type': 'application/json' } });
            const payload = await response.json();
            setDatos(Array.isArray(payload) ? payload : []);
            setLoad(true);
        } catch (error) {
            console.log('Error:', error);
            setDatos([]);
            setLoad(true);
        }
    };

    useEffect(() => {
        cargarNiveles();
    }, []);

    const cabecera = useMemo(() => {
        if (!datos.length) return [];
        const keys = Array.from(
            datos.reduce((set, row) => {
                Object.keys(row || {}).forEach((key) => set.add(key));
                return set;
            }, new Set())
        );
        const idKey = keys.find((key) => key.toLowerCase() === 'id')
            || keys.find((key) => key.toLowerCase().includes('id'));
        const nombreKey = keys.find((key) => key.toLowerCase() === 'nombre');
        const columnas = [idKey, nombreKey].filter(Boolean);
        return columnas.map((key) => ({
            Header: <b>{key === idKey ? 'NIVEL' : key}</b>,
            accessor: key,
            show: true,
            style: { textAlign: 'center' }
        }));
    }, [datos]);

    const obtenerIdKey = (obj) => {
        if (!obj) return null;
        const key = Object.keys(obj).find(k => k.toLowerCase() === 'id');
        return key || 'ID';
    };

    const detalle_dato = (dato) => {
        setNivelActual(dato);
        setFormData({ ...dato });
        setEditando(true);
    };

    const handleChange = (key, value) => {
        setFormData(prev => ({ ...prev, [key]: value }));
    };

    const guardarNivel = async () => {
        try {
            setSaving(true);
            const response = await fetch('/p_niveles', {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData)
            });
            const payload = await response.json().catch(() => ({}));
            if (!response.ok || payload?.status === 'ERROR') {
                throw new Error(payload?.resultado || 'No se pudo actualizar el nivel');
            }
            await cargarNiveles();
            setEditando(false);
            setNivelActual(null);
        } catch (error) {
            console.log(error);
            window.alert(error?.message || 'No se pudo actualizar el nivel');
        } finally {
            setSaving(false);
        }
    };

    const renderFormulario = () => {
        if (!nivelActual) return null;
        const idKey = obtenerIdKey(nivelActual);
        const keys = Object.keys(formData || {}).filter((key) => key.toLowerCase() === 'nombre');

        return (
            <Fragment>
                <div className="card-header" style={{ padding: '15px' }}>
                    <button className="btn btn-outline-light-2x txt-dark" onClick={() => setEditando(false)} disabled={saving}>
                        <i className="icofont icofont-arrow-left" />Regresar
                    </button>
                </div>
                <h4 className="mt-3 ml-4"><strong>Editar Nivel</strong></h4>
                <div className="card-body">
                    <div className="row">
                        {keys.map((key) => (
                            <div className="col-12" key={key}>
                                <div className="form-group">
                                    <label className="form-label">{key}</label>
                                    <input
                                        name={key}
                                        value={formData[key] ?? ''}
                                        onChange={(e) => handleChange(key, e.target.value)}
                                        className="form-control"
                                        type="text"
                                        autoComplete="off"
                                        readOnly={key === idKey}
                                    />
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className="col-md-12 mt-2">
                        <div className="text-right">
                            <Button className="btn-lg mr-4" onClick={guardarNivel} loading={saving}>Guardar</Button>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    };

    return (
        <div className="col-sm-12">
            <div className="card">
                {load ? (
                    editando ? (
                        renderFormulario()
                    ) : (
                        <Fragment>
                            <div className="card-body datatable-react">
                                <Tablereact
                                    myData={datos}
                                    cabecera={cabecera}
                                    pageSize={10}
                                    paginacion={true}
                                    buscador="Buscar"
                                    detalle={detalle_dato}
                                />
                            </div>
                        </Fragment>
                    )
                ) : (
                    <Loader />
                )}
            </div>
        </div>
    );
};

export default Niveles;
